'use es6';

import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { createAction } from '../FormDefinition';
import { SET_CUSTOM_LIFECYCLE_STAGE, RESET_CUSTOM_LIFECYCLE_STAGE } from 'FormsUI/constants/TrackingInteractionKeys/Editor/OptionsTab';
export const UPDATE_LIFECYCLE_STAGE = createAction('UPDATE_LIFECYCLE_STAGE');
export const _updateLifecycleStage = payload => {
  return {
    type: UPDATE_LIFECYCLE_STAGE,
    payload
  };
};
export const updateLifecycleStage = value => dispatch => {
  if (value) {
    trackEditorInteraction(SET_CUSTOM_LIFECYCLE_STAGE, {
      value
    });
  } else {
    trackEditorInteraction(RESET_CUSTOM_LIFECYCLE_STAGE);
  }
  dispatch(_updateLifecycleStage(value));
};
export default updateLifecycleStage;